import React from 'react';
import { FloatingPortal, Placement, useFloating, useHover, useInteractions } from "@floating-ui/react";

interface ITooltipProps extends React.PropsWithChildren  {
    className?: string;
    text: React.JSX.Element | string;
    textStyling?: string;
    placement?: Placement;
    delay?: {
        open: number,
        close: number
    }
}

const Tooltip = (props: ITooltipProps) => {
    const { children, className, delay, placement, text, textStyling } = props;

    const [isOpen, setIsOpen] = React.useState(false);

    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        placement: placement ?? 'top',
        onOpenChange: setIsOpen
    });

    const hover = useHover(context, { delay: {
        open: delay?.open ?? 500,
        close: delay?.close ?? 125,
    }});

    const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

    return (
        <>
            {isOpen && (
                <FloatingPortal>
                    <div
                        className={`floating px-4 py-1 text-sm rounded-2xl bg-[var(--color-text-lighter)] text-white ${textStyling ?? 'border outline-2 border-border-default'}`}
                        ref={refs.setFloating}
                        style={{...floatingStyles, zIndex: 10}}
                        {...getFloatingProps()}
                    >
                        {text}
                    </div>
                </FloatingPortal>
            )}
            <div
                className={`size- justify-end items-end ${className}`}
                ref={refs.setReference}
                {...getReferenceProps()}
            >
                {children}
            </div>
        </>
    );
};

export default Tooltip;
